import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { ComponentheaderService } from 'src/app/services/componentheader.service';
import { ModulemanagementService } from 'src/app/services/modules/modulemanagement.service';

@Component({
  selector: 'app-add-external-media',
  templateUrl: './add-external-media.component.html',
  styleUrls: ['./add-external-media.component.css']
})
export class AddExternalMediaComponent implements OnInit {
  // moduleid: number;
  // currentUserIsAdmin: boolean;
  // moduleInfo: any;
  // mediatitle: string = '';
  mediaurl: string = '';
  @ViewChild('youtubediv') youtubediv: ElementRef;
  iframeurl: string;

  constructor(private activatedroute: ActivatedRoute, public modulemanager: ModulemanagementService, private headerinfo: ComponentheaderService, private router: Router, private toastr: ToastrService) { 
    //this.headerinfo.setHeaderDisplay('Loading...', [], []);
  }

  async ngOnInit() {
    // this.moduleid = parseInt(this.activatedroute.snapshot.queryParams.moduleid);
    // const data: any = await this.modulemanager.getModuleDetails(this.moduleid).toPromise();
    // this.moduleInfo = data.moduleinfo;
    // this.currentUserIsAdmin = data.isViewerAdmin;
    // const schoolName: string = data.schoolName;
    // const schoolid: number = data.schoolID;
    // let moduleDisplayName = this.moduleInfo.name;
    // if(this.moduleInfo.courseCode){
    //   moduleDisplayName += ` (${this.moduleInfo.courseCode})`;
    // }
    
    // this.headerinfo.setHeaderDisplay(
    //   'Upload Media', 
    //   [
    //     {displaytext: 'Home', route: '/user'}, 
    //     {displaytext: schoolName, route: `/user/schoolhome`, params: {schoolID: schoolid}}, 
    //     {displaytext: moduleDisplayName, route: `/user/moduledetails`, params: {moduleID: this.moduleid}},
    //     {displaytext: 'Media Library', route: '/user/modulemedialibrary', params: {moduleid: this.moduleid}},
    //     {displaytext: 'Select from Youtube', route: this.activatedroute.snapshot.url.join('/'), params: this.activatedroute.snapshot.queryParams}
    //   ],
    //   []);
  }

  submit(){

  }

  selectedURLValid(){
    return true;
  }

  extractVideoUrl(){
    var match = this.mediaurl.match(/^(?:(https?):\/\/)?(?:(?:www|m)\.)?youtube\.com\/watch.*v=([a-zA-Z0-9_-]+)/) || this.mediaurl.match(/^(?:(https?):\/\/)?(?:(?:www|m)\.)?youtu\.be\/([a-zA-Z0-9_-]+)/);
    if (match) {
        return (match[1] || 'https') + '://www.youtube.com/embed/' + match[2] + '?rel=0&showinfo=0';
    }
    if (match = this.mediaurl.match(/^(?:(https?):\/\/)?(?:www\.)?vimeo\.com\/(\d+)/)) {
        // eslint-disable-line no-cond-assign
        return (match[1] || 'https') + '://player.vimeo.com/video/' + match[2] + '/';
    }
  }

  urlChanged(){
    
    // <iframe width="560" height="315" src="https://www.youtube.com/embed/Yth7MB2axOo" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
    //<iframe width="560" height="315" src="https://www.youtube-nocookie.com/embed/Yth7MB2axOo" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
    // <iframe class="ql-video" frameborder="0" allowfullscreen="true" src="https://www.youtube.com/embed/Yth7MB2axOo?rel=0&amp;showinfo=0"></iframe>
    if(!this.mediaurl){
      this.youtubediv.nativeElement.innerHTML = '';
    }
    else{
      this.iframeurl = this.extractVideoUrl();
      if(this.iframeurl){
        this.youtubediv.nativeElement.innerHTML = `<iframe class="ql-video mediaiframe mt-4" frameborder="0" allowfullscreen="true" src="${this.iframeurl}"></iframe>`;
      }
      else{
        this.toastr.error('Unable to parse url. Please, confirm that the url is a valid YouTube or Vimeo url');
      }
    }  
  }

  clear(){
    this.mediaurl = ''
    this.urlChanged();
  }

}
